import React, { useState } from 'react'

import { Box, Button, Card, CardContent, CardHeader, Grid } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { CompanyDetails, CompanyIpRanges, MarkAsIsp, RequestChange } from 'components/company'
import CompanyAiEnrichButton from 'components/company/CompanyAiEnrichButton'
import LoadingView from 'components/LoadingView'
import { useCompany } from 'hooks/useCompany'
import { usePendingCompanyDataChangeRequests } from 'hooks/useDataChangeRequests'
import { getChangeRequestInitialData } from 'utils/data-change-requests'

const Company = () => {
  const { uuid } = useParams()
  const navigate = useNavigate()
  const { data, isLoading, error } = useCompany(uuid)
  const pendingQuery = usePendingCompanyDataChangeRequests(uuid)
  const pending = pendingQuery.data ?? []
  const [modal, setModal] = useState<string | null>(null)

  const handleCloseModal = () => setModal(null)

  const renderActions = (company: any) => {
    const pendingCount = pending.length
    const multiple = pendingCount > 1
    const redirectUrl = multiple
      ? UrlProvider.getUrl('dataChangeRequests')
      : UrlProvider.getUrl('dataChangeRequests.view', { id: pending[0]?.id })

    return (
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <CompanyAiEnrichButton
          companyCountry={company.country}
          companyDomain={company.website}
          companyName={company.name}
          companyUuid={company.uuid}
          onComplete={() => pendingQuery.refetch()}
        />
        {pendingCount ? (
          <Button color="primary" onClick={() => navigate(redirectUrl)} variant="contained">
            {`Go to pending request${multiple ? `s (${pendingCount} TOTAL)` : ''} `}
          </Button>
        ) : null}
        <Button color="primary" disabled={!!pendingCount} onClick={() => setModal('requestChange')} variant="contained">
          Request change
        </Button>
        <Button color="primary" disabled={!!pendingCount} onClick={() => setModal('markAsIsp')} variant="contained">
          Mark as ISP
        </Button>
      </Box>
    )
  }

  return (
    <Card>
      <LoadingView error={error ? 'Error occurred when loading company data' : undefined} loading={isLoading}>
        {data && (
          <>
            <CardHeader action={renderActions(data.company)} title={data.company.name || 'Company'} />
            <CardContent>
              <Grid container spacing={4}>
                <Grid size={{ sm: 7 }}>
                  <CompanyDetails data={data.company} />
                </Grid>
                <Grid size={{ sm: 5 }}>
                  <CompanyIpRanges ipRanges={data.ipRanges} />
                </Grid>
              </Grid>
            </CardContent>
          </>
        )}
      </LoadingView>
      <MarkAsIsp onClose={handleCloseModal} open={modal === 'markAsIsp'} />
      {modal === 'requestChange' && data && (
        <RequestChange
          initialValues={getChangeRequestInitialData(data)}
          onClose={handleCloseModal}
          onSubmit={handleCloseModal}
          open={modal === 'requestChange'}
        />
      )}
    </Card>
  )
}

export default Company
